/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 draws a browser-share donut.`)
};

const es_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 dibuja una dona de cuota de navegadores.`)
};

const de_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 zeichnet ein Donut-Diagramm zum Browseranteil.`)
};

const nl_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 tekent een browserverdelingsdonut.`)
};

const fr_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 dessine un anneau de parts de navigateurs.`)
};

const it_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 disegna una ciambella delle quote di browser.`)
};

const pt_br2_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 desenha uma rosca de participação de navegadores.`)
};

const pt_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 desenha uma rosca de quota de navegadores.`)
};

const ja_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 でブラウザシェアのドーナツグラフが描画されます。`)
};

const zh_donut_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 绘制出浏览器份额环形图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_ex1", locale)
	if (locale === "en") return en_donut_ex1(inputs)
	if (locale === "es") return es_donut_ex1(inputs)
	if (locale === "de") return de_donut_ex1(inputs)
	if (locale === "nl") return nl_donut_ex1(inputs)
	if (locale === "fr") return fr_donut_ex1(inputs)
	if (locale === "it") return it_donut_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_donut_ex1(inputs)
	if (locale === "pt") return pt_donut_ex1(inputs)
	if (locale === "ja") return ja_donut_ex1(inputs)
	return zh_donut_ex1(inputs)
};